module.exports = __webpack_public_path__ + "static/img/lxgp1.6bd7e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/lxgp1.jpg
// module id = iL01
// module chunks = 0